import styled from 'styled-components'
import { Image } from 'react-bootstrap'

const LogoImage = styled(Image)`
  display: block;
  margin: 2rem auto auto;
  max-height: 200px;
  width: 60%;
`

export { LogoImage }
